export interface UseCase {
  id: string;
  title: string;
  icon: string;
  suggestions: string[];
  defaultText: string;
}

export const useCases: UseCase[] = [
  {
    id: 'remove-background',
    title: 'Remove Background',
    icon: 'ai-remove-background',
    suggestions: ['Remove background...'],
    defaultText: 'Remove the background to isolate the subject of the video...',
  },
  {
    id: 'change-background',
    title: 'Change background',
    icon: 'ai-change-background',
    suggestions: [
      'Change weather...',
      'Change lighting...',
      'Change backdrop...',
      'Use background from reference image...',
    ],
    defaultText: 'Change the styling or details of the video background...',
  },
  {
    id: 'change-object',
    title: 'Change object',
    icon: 'ai-change-object',
    suggestions: [
      'Change color...',
      'Replace object...',
      'Change subject...',
      'Remove object...',
    ],
    defaultText: 'Modify, replace or delete a prominent object in the video...',
  },
  {
    id: 'change-colors',
    title: 'Change colors',
    icon: 'ai-change-colors',
    suggestions: [
      'Make color palette cooler/warmer...',
      'Match color palette to reference image...',
    ],
    defaultText: 'Modify the color palette of the video...',
  },
  {
    id: 'change-video-style',
    title: 'Change video style',
    icon: 'ai-change-video-style',
    suggestions: ['Make video animated...', 'Match style of image...'],
    defaultText: 'Modify the styling and aesthetics of a video...',
  },
  {
    id: 'custom-edit',
    title: 'Custom edit',
    icon: 'ai-custom-edit',
    suggestions: [
      'Add elements...',
      'Change motion...',
      'Add effects...',
      'Change framing...',
      'Change mood...',
    ],
    defaultText:
      'Apply open-ended transformations to customize the video in your own way...',
  },
];
